import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useFetch } from "@/hooks/useFetch";
import { getOrderDetail } from "@/api/orders";

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get("orderId");

  const { data: order, loading } = useFetch(
    () => (orderId ? getOrderDetail(orderId) : Promise.reject("no orderId")),
    [orderId],
  );

  useEffect(() => {
    if (!orderId) {
      navigate("/my-orders", { replace: true });
    }
  }, [orderId, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <i className="ri-loader-4-line animate-spin text-3xl text-[#C9A96E]"></i>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFF8F0] via-white to-[#FFF0E6] flex items-center justify-center px-6">
      <div className="w-full max-w-md text-center">
        <div className="bg-white rounded-3xl shadow-xl p-10">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-check-line text-4xl text-green-600"></i>
          </div>

          <h1 className="text-2xl font-medium text-gray-800 mb-2">
            결제가 완료되었습니다
          </h1>
          <p className="text-sm text-gray-500 mb-8">
            주문이 접수되었습니다. AI 웨딩 사진 제작이 곧 시작됩니다.
          </p>

          {order && (
            <div className="bg-gray-50 rounded-xl p-6 mb-8 text-left space-y-3">
              <div className="flex justify-between text-sm">
                <span className="text-gray-500">주문번호</span>
                <span className="font-medium text-gray-800">
                  {order.orderId}
                </span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-500">상품</span>
                <span className="font-medium text-gray-800">
                  {order.productName}
                </span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-500">결제 금액</span>
                <span className="font-medium text-[#C9A96E]">
                  {order.amount?.toLocaleString()}원
                </span>
              </div>
            </div>
          )}

          <button
            onClick={() => navigate("/my-orders")}
            className="w-full bg-[#2D2D2D] text-white py-4 rounded-xl font-medium hover:bg-[#1a1a1a] transition-all cursor-pointer"
          >
            내 주문 확인하기
          </button>
        </div>
      </div>
    </div>
  );
}
